// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import BlockSvg from '@rsuite/icon-font/lib/action/Block';
var Block = createSvgIcon({
  as: BlockSvg,
  ariaLabel: 'block',
  category: 'action',
  displayName: 'Block'
});
export default Block;